import { getDispatcher } from "@trailhead/analytics";

export enum PossibleOS {
  IOS = "iOS",
  ANDROID = "android",
  MAC = "mac",
  WINDOWS = "windows",
  LINUX = "linux",
  UNKNOWN = "unknown",
}

export const checkOS = (): PossibleOS => {
  const userAgent = navigator.userAgent;

  if (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes((getDispatcher().context.ExtraData.OsType as string) ?? "")
  ) {
    return PossibleOS.IOS;
  } else if (/Mac/.test(userAgent)) {
    return PossibleOS.MAC;
  } else if (/android/i.test(userAgent)) {
    return PossibleOS.ANDROID;
  } else if (/Windows/.test(userAgent)) {
    return PossibleOS.WINDOWS;
  } else if (/Linux/.test(userAgent)) {
    return PossibleOS.LINUX;
  }
  return PossibleOS.UNKNOWN;
};
